const LARGE = 1279;

const toggleAccordions = () => {
  $( 'footer.chr-footer .footer-links-group' ).each( function() {
    let tab = $( this );
    let name = tab.find( 'h4' );

    name.on( 'click', function() {

      if ( window.innerWidth >= LARGE ) {
        return;
      }

      name.parent().toggleClass( 'active' );
      name.next().slideToggle();
    });
  });

};

const resetLinksGroup = () => {
  $( 'footer.chr-footer .footer-links-group' ).each( function( evt ) {
    $( this ).removeClass( 'active' );
    $( this ).find( '.links' ).attr( 'style', '' );
    if ( ! evt ) {
      $( this ).addClass( 'active' );
      $( this ).find( '.links' ).attr( 'style', 'display:block' );
    }
  });
};

$( document ).ready( function() {
  toggleAccordions();

  $( window ).resize( function() {
    if ( window.innerWidth > LARGE ) {
      resetLinksGroup();
    }
  });
});

